import React from "react";

class Header extends React.Component {

    render() {
        return (

            <main id="main">
                <div className="container">
                    <div className="page-title">
                        Oops! Page Not Found    
                     </div>
                     <div className="img-container">
                       <a href="https://nogin.com" target="_blank">
                         <img src="/returns/img/NOGIN-PoweredBy.png" alt="Powered by Nogin" width="240px"/>
                       </a>
                     </div>
                </div>
            </main>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/PageNotFound.js